import { styled } from 'styled-components';
import { PanelControls } from '~/components/ui/PanelControls';
import { ShopLogo } from '../../components/ShopLogo';
import { VehicleList } from '../../components/VehicleList';
import { VehicleListControls } from '../../components/VehicleListControls';

const StyledShopLogo = styled(ShopLogo)`
	position: absolute;
	left: 60px;
	top: 60px;
	user-select: none;
`;

const StyledVehicleList = styled(VehicleList)`
	position: absolute;
	bottom: 120px;
	user-select: none;
`;

const StyledVehicleListControls = styled(VehicleListControls)`
	position: absolute;
	right: 60px;
	bottom: 360px;
	user-select: none;
`;

const StyledListLabel = styled.div`
	position: absolute;
	height: 20px;
	left: 60px;
	bottom: 360px;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0 6px;
	border-radius: 6px;
	font-family: 'GT Walsheim Pro';
	font-size: 10px;
	font-weight: bold;
	text-transform: uppercase;
	color: #262628;
	background: white;
	user-select: none;
`;

const StyledMenuControlsLeft = styled(PanelControls).attrs({ align: 'left' })`
	position: absolute;
	left: 60px;
	bottom: 60px;
`;

const StyledMenuControlsRight = styled(PanelControls).attrs({ align: 'right' })`
	position: absolute;
	right: 60px;
	bottom: 60px;
`;

const StyledInterfaceContainer = styled.div`
	opacity: 1;
	transition: opacity 0.3s ease;

	&.interface-enter {
		opacity: 1;
	}

	&.interface-enter-active,
	&.interface-enter-done,
	&.interface-exit {
		opacity: 0;
	}

	&.interface-exit-active {
		opacity: 1;
	}
`;

export {
	StyledShopLogo,
	StyledVehicleList,
	StyledVehicleListControls,
	StyledListLabel,
	StyledMenuControlsLeft,
	StyledMenuControlsRight,
	StyledInterfaceContainer,
};
